<cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="componentSpecification | async" (sortTriggered)="onSort($event)"
  (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilter()" [dataTotalCount]="specificationTotalCount | async"
  [isLoading]="isSpecificationLoading">
</cal-calsiumlist-listing>

<cal-pagination [paging]="specificationPaging | async" (pageChange)="onPaging($event)" [dataTotalCount]="specificationTotalCount | async">
</cal-pagination>
<hr />